import { useTranslation } from 'react-i18next';

import { Skeleton, useBalanceContext } from 'components';
import { formatLocalizedCurrency } from 'helpers';

import TravelBalancePaymentMethod from './TravelBalancePaymentMethod';

const TravelBalanceValidationStep = () => {
  const { t } = useTranslation();
  const { travelOrder, orderLoading } = useBalanceContext();

  return (
    <>
      <h2 className="h2 underlined-blue mb-6">{t('purchase:balance.balancePayment')}</h2>

      {orderLoading ? (
        <div>
          <Skeleton classNames="w-80 h-8 mb-3" />
          <Skeleton classNames="w-80 h-8 mb-3" />
          <Skeleton classNames="w-80 h-8 mb-3" />
          <Skeleton classNames="w-80 h-8 mb-3" />
        </div>
      ) : (
        <>
          <div className="font-bold">
            <p className="flex items-center gap-2">
              <span className="text-gray-500">{t('purchase:balance.reference')}:</span>
              <span>{travelOrder?.order?.ref}</span>
            </p>

            <p className="flex items-center gap-2">
              <span className="text-gray-500">{t('purchase:balance.creationDate')}:</span>
              <span>{travelOrder?.order?.date}</span>
            </p>

            <p className="flex items-center gap-2">
              <span className="text-gray-500">{t('purchase:balance.status')}:</span>
              <span>{travelOrder?.status}</span>
            </p>

            {travelOrder?.order?.amountAfterSubsidy !== travelOrder?.order?.amount && (
              <>
                <p className="flex items-center gap-2">
                  <span className="text-gray-500">{t('purchase:balance.amount')}:</span>
                  <span>{formatLocalizedCurrency(travelOrder?.order?.amount)}</span>
                </p>
                <p className="flex items-center gap-2">
                  <span className="text-gray-500">{t('purchase:balance.amountAfterSubsidy')}:</span>
                  <span>{formatLocalizedCurrency(travelOrder?.order?.amountAfterSubsidy)}</span>
                </p>
              </>
            )}
            <p className="flex items-center gap-2">
              <span className="text-gray-500">{t('purchase:balance.amountOutstanding')}:</span>
              <span>{formatLocalizedCurrency(travelOrder?.order?.balance)}</span>
            </p>
          </div>
        </>
      )}
      <TravelBalancePaymentMethod />
    </>
  );
};

export default TravelBalanceValidationStep;
